import { render, staticRenderFns } from "./TablaReservaCompra.vue?vue&type=template&id=25c97d56&"
import script from "./TablaReservaCompra.vue?vue&type=script&lang=js&"
export * from "./TablaReservaCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports